import api from "@/api/index"
import endpoints from "@/api/endpoints"
import { ITransform } from "@/types/dags"

export const fetchDags = async () => {
  return await api.get(endpoints.DAGS)
}

export const fetchDagRulesById = async (id: string) => {
  return await api.get(endpoints.DAGS_RULES_ID(id))
}

export const fetchJsonById = async (id: string) => {
  return await api.get(endpoints.JSON_ID(id))
}

export const uploadJson = async (data: any) => {
  return await api.post(endpoints.PUT_JSON, data)
}

export const fetchETLDirectory = async (subPath?: string) => {
  const modPath = subPath?.replace("//", "/")
  return await api.get(endpoints.ELT_DIRECTORY(modPath))
}

export const removeAFile = async (subPath: string) => {
  const modPath = subPath?.replace("//", "/")
  return await api.get(endpoints.REMOVE_FILE(modPath))
}

export const removeADir = async (subPath: string) => {
  const modPath = subPath?.replace("//", "/")
  return await api.get(endpoints.REMOVE_DIR(modPath))
}

export const createADir = async (subPath: string) => {
  const modPath = subPath?.replace("//", "/")
  return await api.get(endpoints.CREATE_DIR(modPath))
}

export const fetchDagsExtract = async (id: string) => {
  return api.get(endpoints.DAGS_EXTRACT(id))
}

export const fetchDagsTransform = async (id: string) => {
  return api.get(endpoints.DAGS_TRANSFORM(id)).then((res) => res.data)
}

export const fetchDagsLoad = async (id: string) => {
  return api.get(endpoints.DAGS_LOAD(id)).then((res) => res.data)
}

export const fetchDagsPublish = async (id: string) => {
    return api.get(endpoints.DAGS_PUBLISH(id)).then((res) => res.data)
}

export const fetchAccessRoles = async () =>
  api.get(endpoints.ACCESSES).then((res) => res.data)

export const fetchDataLicences = async () =>
  api.get(endpoints.DATA_LICENCES).then((res) => res.data)

export const fetchGeoLevel = () =>
  api.get(endpoints.GEO_LEVEL).then((res) => res.data)

export const fetchDataOrganisations = async () =>
  api.get(endpoints.DATA_ORGANISATIONS).then((res) => res.data)

